import { LocationIdModel } from "./locationIdModel";

export class AvailabilityGridModel {
    id: number = 0;
    displayValue: string = '';
    rotation: UserRotation[] = [];
}



export class UserRotation {
    isAvailable: boolean = false;
    dayOfWeek: number = 0;
    startTime: Date[] = [];
    endTime: Date[] = [];
    userWorkLocation: LocationIdModel[] = [];
    userHoursOfOperationId: number[] = [];
    eligibleForInPersonAppointments: boolean = false;
    eligibleForPhoneAppointments: boolean = false;
    eligibleForVirtualAppointments: boolean = false;
}